import { useNavigate } from 'react-router';
import DoneIcon from '@mui/icons-material/Done';
import { Typography } from '@components/Typography';
import { ExternalLink } from '@components/Link';
import { useTranslation } from '@hooks';
import { HelpCenterIcon } from 'assets/images/sidebar';

const Card = ({ title, description, link, internalLink, isPassed, style }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const onClickInternalLink = () => navigate(internalLink);
    return (
        <div
            style={{ display: 'grid', gridGap: '18px', gridTemplateColumns: '20px 1fr', ...style }}
            className="home-onboarding-item"
        >
            <div
                style={{
                    height: 20,
                    width: 20,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: isPassed ? 'var(--primary-main)' : '#fff',
                    borderRadius: '50%',
                    border: isPassed ? '1px solid #1F4C5C' : '1px solid rgba(0, 0, 0, 0.12)',
                    marginTop: '2px',
                    cursor: isPassed ? 'default' : 'pointer',
                }}
                onClick={isPassed ? undefined : onClickInternalLink}
            >
                {isPassed ? <DoneIcon sx={{ width: 14, height: 14, color: '#fff' }} /> : null}
            </div>
            <div>
                <Typography
                    variant="subtitle2"
                    sx={{
                        color: isPassed ? 'var(--text-tertiary)' : 'var(--text-primary)',
                        marginBottom: '8px',
                        textDecoration: isPassed ? 'line-through' : '',
                        cursor: isPassed ? 'default' : 'pointer',
                    }}
                    onClick={isPassed ? undefined : onClickInternalLink}
                >
                    {title}
                </Typography>
                <Typography
                    variant="caption"
                    sx={{
                        color: isPassed ? 'var(--text-tertiary)' : 'rgba(0, 0, 0, 0.60)',
                        display: 'block',
                        marginBottom: '8px',
                    }}
                >
                    {description}
                </Typography>
                {!isPassed ? (
                    <Typography variant="caption">
                        <ExternalLink
                            href={link}
                            underline="none"
                            sx={{ display: 'flex', '& svg path': { fill: 'var(--primary-main)', fillOpacity: '1' } }}
                        >
                            <HelpCenterIcon height={14} width={14} style={{ marginRight: '8px' }} />
                            {t('common.learnMore')}
                        </ExternalLink>
                    </Typography>
                ) : null}
            </div>
        </div>
    );
};

export default Card;
